import React, {useContext, useRef} from 'react';
import { Calendar, addLocale } from 'primereact';
import {FormContext} from "./Form";
import ReactDOM from "react-dom";

addLocale("es", {
  firstDayOfWeek: 1,
  showMonthAfterYear: true,
  dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
  dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
  today: "Hoy",
  clear: "Limpiar",
});

export function DateField(props) {
  const { mostrarIcono, name, label } = props;
  const { value, setValue } = useContext(FormContext);
  const calendarEl = useRef(null);

  if (!value) {
    return "DateField debe este dentro de un SimpleForm";
  }

  const styles = {
    padding: "4px 8px",
    borderRadius: "3px",
    border: "#97bdc1 solid 1px",
    boxShadow: "2px 2px 0 #d7e6e7, -2px 2px 0 #d7e6e7, 2px -2px 0 #d7e6e7, -2px -2px 0 #d7e6e7",
    width: 'unset'
  };
  const iconStyles = {
    cursor: "pointer",
    position: "absolute",
    right: "20px",
    top: "2.5px",
  };
  const containerStyles = {
    display: "flex",
    position: "relative",
  };
  return (
    <React.Fragment>
      <label className="label">{label}</label>
      <div className="control" style={containerStyles}>
        <Calendar
          ref={calendarEl}
          dateFormat="dd/mm/yy"
          mask="99/99/9999"
          locale="es"
          inputStyle={styles}
          value={value(name)}
          onChange={(event) => {
            setValue(name, event.value);
          }}
        />
        {mostrarIcono && (
          <div
            onClick={() => {
              calendarEl.current.show();
            }}
            style={iconStyles}
          >
            <img className="ui-datepicker-trigger" src="/img/Calendar.png" />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
